var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lazy-loading" },
    [
      _c("img", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loaded,
            expression: "loaded"
          }
        ],
        ref: "backgroundImg",
        class: _vm.customClass,
        attrs: { alt: _vm.alt, src: _vm.inViewport && _vm.src },
        on: {
          load: function($event) {
            _vm.loaded = true
          }
        }
      }),
      _c("BasePreloader", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.loaded,
            expression: "!loaded"
          }
        ]
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1728af7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1728af7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/_UI/BaseLazyLoadingimg.vue
// module id = Tbgb
// module chunks = 13